const EVENTS = new Set([
  "verification_required",
  "authenticated_tokens_accepted",
  "session_cleared",
  "session_state_synced",
]);

/**
 * Tiny explicit state machine for the global uncleared-session gate. Merely
 * syncing cached state must never erase a server verification requirement.
 */
export function reduceContactVerificationGate(current, event) {
  if (!EVENTS.has(event)) throw new Error("invalid_contact_verification_gate_event");
  if (event === "verification_required") return true;
  if (event === "session_state_synced") return Boolean(current);
  return false;
}
